import React, { useState } from 'react';
import { QrCode, Camera } from 'lucide-react';
import { QRScanner } from './QRScanner';

export function SplashScreen() {
  const [showScanner, setShowScanner] = useState(false);

  const handleScan = (result: string) => {
    // Navigate to the scanned URL
    window.location.href = result;
  };

  if (showScanner) {
    return <QRScanner onScan={handleScan} onClose={() => setShowScanner(false)} />;
  }

  return (
    <div className="fixed inset-0 z-50 bg-gradient-to-br from-[#FFF3A3]/20 via-[#FFC857]/20 to-[#1E9C53]/20 flex items-center justify-center p-6">
      <div className="w-full max-w-sm text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-2xl flex items-center justify-center">
            <img
              src="/favicon.webp"
              alt="gallery g logo"
              className=""
            />
          </div>
        </div>
        
        {/* QR Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 rounded-2xl border-2 border-dashed border-gray-600 
                          flex items-center justify-center">
            <QrCode className="w-12 h-12 text-gray-500" />
          </div>
        </div>
        
        {/* Message */}
        <h1 className="text-xl font-semibold text-gallery-dark mb-2">
          Welcome to Gallery-G
        </h1>
        <p className="text-gray-600 mb-8">
          Scan the QR code near the artwork to listen to the audio experience
        </p>
        
        {/* Scan Button */}
        <button
          onClick={() => setShowScanner(true)}
          className="w-full py-4 px-6 rounded-xl bg-gallery-accent text-white 
                     font-semibold flex items-center justify-center gap-2
                     hover:bg-opacity-90 transition-colors"
        >
          <Camera className="w-5 h-5" />
          Scan QR Code
        </button>
      </div>
    </div>
  );
}
